export default __webpack_public_path__ + "static/media/creditcard-plus-no-ribbon.85d13a0a.svg";